import React from 'react';
import ListView from './ListView';
export default function Packages(){
  return <ListView icon="packages" title="Skill Packages" subtitle="Versioned, registry-tracked builds of each skill." path="/packages" columns={["id","skill_id","version","registry","integrity_hash"]} mapRow={r=>r} queryParam="version"/>;
}
